<template>
  <div class="border_dark" style="">
    <div class="color_blue" style="display: flex">
      <div style="float: left">{{ $t('inwardList.table.columns.totalBoxes') }}:{{ box.length }}</div>
      <div style="text-align: center; margin-left: auto">
        {{ $t('orders.totalQTY') }}:{{ qty }}
      </div>
      <div style="text-align: center; float: right; margin-left: auto">
        {{ $t('packingb2b.totalWeight') }}:{{ totalBoxweight }}
      </div>
    </div>
    <div class="row" style="padding: 0px 5px 10px 5px">
      <div class="col-md-6">
        <b-form-input
          type="text"
          id="searchboxid"
          :placeholder="$t('ShippingDetails.boxIDPlaceHolder')"
          v-model="searchboxid"
        ></b-form-input>
      </div>

      <div class="col-md-3">
        <button
          type="button"
          class="btn btn-primary"
          style="width: 100%"
          @click="searchbox"
        >
         {{ $t('common.searchBtn') }}
        </button>
      </div>
      <div class="col-md-3">
        <button
          type="button"
          class="btn btn-danger"
          style="width: 100%"
         @click="resetSearchBox"
        >
        {{ $t('common.resetBtn') }}
        </button>
      </div>
    </div>

    <div style="height: 60vh; width: 100%; overflow: scroll">
      <div v-for="(boxitem,boxid) in box" v-bind:key="boxid" class="form-group">
        <singleBox :boxdata="boxitem" :clientid="clientid" key=abc :disableflag="disableflag"></singleBox>
      </div>
    </div>
  </div>
</template>

<script>
import SingleBox from "./singlepackingbox.vue";

export default {
  name: "packingBoxList",
  components: { SingleBox },
  props: ["box", "qty","clientid","disableflag"],

  data: function () {
    return {
      searchboxid:'',
    tempbox:[],
    totalBoxweight:0
    };
  },
  mounted() {
     this.totalBoxweight= this.box.reduce((total,e)=>{return total+=Number(e.weight)},0)
  },
    computed: {

  searchbox(){
    if(this.searchboxid!=""){
   


        this.box=this.tempbox.filter(e =>{
          console.log(e,"rrr")
          if(e.boxid.includes(this.searchboxid))
          return e;
        })
    }else{
      if(this.box.length<this.tempbox.length)
       this.box=[...this.tempbox]
       else
         this.tempbox=[...this.box]
    }

  console.log(this.tempbox,"tempbix",this.box)
    }
       },
  methods: {
    resetSearchBox(){
      document.getElementById("searchboxid").value="";
      this.searchboxid="";
    },
    selectType1(type){
          console.log("median",type)
         
}
  },
};
</script>

<style>
.color_blue {
  background-color: #20a8d8;
  height: 30px;
  border: 1px solid #163a2f;
  border-radius: 5px;
  margin: 0 0 0.6rem;
  padding: 5px 10px;
  color: white;
}
.border_dark {
  border: 1px solid #ffffff;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(148, 150, 151, 0.747);
}
</style>


// WEBPACK FOOTER //
// src/views/common_components/packingBoxList.vue?4b9984f1